import http from "@/axios/http-common";
import {
  SpesimenLab,
  SpesimenLabFhirResponse,
  SpesimenLabIndexResponse,
  SpesimenLabPayload
} from "@/types/spesimen_lab";

async function getByRegister(
  registerId: string | number
): Promise<SpesimenLabIndexResponse> {
  const response = await http.getData(`/register/${registerId}/spesimen-lab`);
  return response.data;
}

async function create(data: SpesimenLabPayload): Promise<SpesimenLab> {
  const response = await http.postData("/spesimen-lab", data);
  return response.data.data;
}

async function update(
  id: number,
  data: SpesimenLabPayload
): Promise<SpesimenLab> {
  const response = await http.putData(`/spesimen-lab/${id}`, data);
  return response.data.data;
}

async function destroy(id: number): Promise<void> {
  await http.deleteData(`/spesimen-lab/${id}`);
}

async function fhir(id: number): Promise<SpesimenLabFhirResponse> {
  const response = await http.getData(`/spesimen-lab/${id}/fhir`);
  return response.data;
}

export default {
  getByRegister,
  create,
  update,
  destroy,
  fhir
};
